// HomeViews.js
import React from 'react';
import MobileHome from './HomeMobile';
import DesktopHome from './Home';
import useIsMobile from './useIsMobile';

function HomeViews() {
  const isMobile = useIsMobile();

  return (
    <div>
      {isMobile ? <MobileHome /> : <DesktopHome />}
    </div>
  );
}

export default HomeViews;
